import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import "@/lib/installPrompt";
import "@/lib/utcDates";
import "@/lib/apiErrors";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

const isAdminPath = /^\/(admin|aqh-mgmt-7816)/.test(window.location.pathname) || (window.location.pathname === '/app' && new URLSearchParams(window.location.search).get('app') === 'admin');
if (isAdminPath) {
  const link = document.querySelector('link[rel="manifest"]'); if (link) link.href = '/manifest-admin.json';
  const apple = document.querySelector('link[rel="apple-touch-icon"]'); if (apple) apple.href = '/apple-touch-icon-admin.png';
  const title = document.querySelector('meta[name="apple-mobile-web-app-title"]'); if (title) title.content = 'AQH Admin';
}
if ('serviceWorker' in navigator && (window.location.pathname.startsWith('/employee') || window.location.pathname === '/app' || isAdminPath)) {
  window.addEventListener('load', () => { navigator.serviceWorker.register('/sw.js').catch(() => {}); });
}
